import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/js/utils';

//const input = document.querySelector('input[type="tel"]');
// intlTelInput(input, {
//     // any initialisation options go here
// });
(function( $ ) {
    window.intlTelInputGlobals.loadUtils("build/js/utils.js");

    $('#form-field-phone, input[name="form_fields[phone]"], input[name="form_fields[phone2]"], #form-field-field_phone_project').each(function(){
        $(this).addClass('form-field-phone');
    });
    if($('.form-field-phone').length > 0) {
        $('.form-field-phone').each(function(){
            let input = $(this).get(0)
            let validation = $(this).data('validation')

            // Sprawdzenie domeny strony
            let domain = window.location.hostname.split('.').pop();
            let initialCountrySetting;

            if (domain === 'com') {
                initialCountrySetting = "auto"; // Auto dla .com
            } else {
                initialCountrySetting = "pl"; // Domyślnie Polska dla innych domen
            }

            let iti = intlTelInput(input, {
                hiddenInput: "intl_phone",
                allowDropdown: false,
                initialCountry: initialCountrySetting,
                autoPlaceholder: 'off',
                geoIpLookup: function(callback) {
                  if (initialCountrySetting === "auto") {
                      $.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
                          var countryCode = (resp && resp.country) ? resp.country : "us"; // Default to "us" if no result
                          callback(countryCode);
                      });
                  }
                }
            });
            
            input.addEventListener('blur', function() {
                if (input.value.trim()) {
                    if (iti.isValidNumber()) {
                        input.classList.remove("error");
                        input.setCustomValidity('');
                        input.setAttribute("isvalid", "false")
                    } else {
                        input.classList.add("error");
                        input.setCustomValidity(validation);
                        input.setAttribute("isvalid", "true")
                    }
                }
            });

            $('input[name="intl_phone"]').addClass('prefix-phone');
            $('input[name*="intl_phone"]').addClass('prefix-phone');
        });
    }

    // $('.elementor-form button[type="submit"]').click(function(){      
    //   if($(this).closest('.elementor-form').find('.form-field-phone').length > 0) {
    //     var phone = $(this).closest('.elementor-form').find('.prefix-phone').val().replaceAll(' ', '');
    //     $(this).closest('.elementor-form').find('.form-field-phone').val(phone);
    //   }
    // });

    $('.elementor-form').submit(function(){      
      if($(this).closest('.elementor-form').find('.form-field-phone').length > 0) {
        var phone = $(this).find('.prefix-phone').val().replaceAll(' ', '');
        $(this).find('.form-field-phone').val(phone);
        let that = $(this)
        setTimeout(function(){           
          var phone = that.find('.form-field-phone').val();
          phone.substring(0, 3);
          phone = that.find('.form-field-phone').val(phone);
        }, 150);
      }
    });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/phone-fields.js